import { useState } from "react";
import { fotosPendentes } from "@/mocks/coletor";

interface FieldPhotosProps {
  onClose: () => void;
}

export default function FieldPhotos({ onClose }: FieldPhotosProps) {
  const [fila, setFila] = useState(fotosPendentes);
  const [novaFoto, setNovaFoto] = useState(false);

  const tipos = ["Geral", "Copa", "Tronco", "Raiz", "Interferência", "Dano"];

  return (
    <div className="px-4 pt-4 pb-20 max-w-lg mx-auto">
      {/* Header */}
      <div className="flex items-center gap-2 mb-5">
        <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[#E8EAED] flex items-center justify-center">
          <i className="ri-arrow-left-line text-[#3F4A52] text-lg" />
        </button>
        <h2 className="text-lg font-heading font-bold text-[#3F4A52]">Fotos</h2>
      </div>

      {/* Botões de captura */}
      <div className="flex gap-2 mb-5">
        <button
          onClick={() => setNovaFoto(true)}
          className="flex-1 py-4 rounded-xl bg-[#1B6E4F] text-white font-heading font-bold text-sm flex items-center justify-center gap-1.5 active:scale-[0.98] transition-transform"
        >
          <i className="ri-camera-line text-lg" /> Capturar foto
        </button>
        <button className="flex-1 py-4 rounded-xl border border-[#E8EAED] text-sm font-medium text-[#3F4A52] flex items-center justify-center gap-1.5">
          <i className="ri-image-line text-lg" /> Galeria
        </button>
      </div>

      {/* Modal de nova foto */}
      {novaFoto && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end">
          <div className="bg-white w-full rounded-t-2xl p-5 max-w-lg mx-auto">
            <h3 className="text-base font-heading font-bold text-[#3F4A52] mb-4">Nova foto</h3>
            <div className="bg-[#E8EAED] rounded-xl h-48 flex items-center justify-center mb-4">
              <div className="text-center">
                <i className="ri-camera-line text-4xl text-[#3F4A52]/30" />
                <p className="text-sm text-[#3F4A52]/40 mt-2">Toque para capturar</p>
              </div>
            </div>
            <div className="space-y-3">
              <select className="w-full px-3 py-2.5 rounded-xl border border-[#E8EAED] text-sm text-[#3F4A52]">
                {tipos.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
              <input type="text" placeholder="Descrição da foto" className="w-full px-3 py-2.5 rounded-xl border border-[#E8EAED] text-sm" />
              <input type="text" placeholder="Vincular à árvore (código CTA)" className="w-full px-3 py-2.5 rounded-xl border border-[#E8EAED] text-sm font-mono" />
              <div className="flex gap-2">
                <button onClick={() => setNovaFoto(false)} className="flex-1 py-3 rounded-xl border border-[#E8EAED] text-sm font-medium text-[#3F4A52]">
                  Cancelar
                </button>
                <button onClick={() => setNovaFoto(false)} className="flex-1 py-3 rounded-xl bg-[#1B6E4F] text-white font-heading font-bold text-sm">
                  Salvar na fila
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fila de fotos pendentes */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-heading font-bold text-[#3F4A52]">Fila de pendentes</h3>
          <span className="text-xs px-2 py-0.5 rounded-full bg-[#F57C00]/15 text-[#F57C00] font-medium">{fila.length} fotos</span>
        </div>
        <div className="space-y-2">
          {fila.map((foto) => (
            <div key={foto.id} className="flex items-center gap-3 p-3 rounded-xl border border-[#E8EAED] bg-white">
              <div className="w-14 h-14 rounded-xl bg-[#E8EAED] flex items-center justify-center flex-shrink-0 overflow-hidden">
                <i className="ri-image-line text-[#3F4A52]/30 text-xl" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-xs font-medium px-1.5 py-0.5 rounded bg-[#E8EAED] text-[#3F4A52]">{foto.tipo}</span>
                  <span className="text-xs text-[#3F4A52]/50 font-mono truncate">{foto.arvore}</span>
                </div>
                {foto.descricao && <p className="text-sm text-[#3F4A52] truncate">{foto.descricao}</p>}
                <p className="text-[10px] text-[#3F4A52]/40 mt-0.5">{foto.data} · {foto.tamanho}</p>
              </div>
              <button className="w-7 h-7 rounded-lg bg-[#FFEBEE] text-[#D32F2F] flex items-center justify-center flex-shrink-0">
                <i className="ri-delete-bin-line text-xs" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}